import React from 'react';
import PropTypes from 'prop-types';

const PageContent = ({ children }) => {
	// flex-grow-1
	return <div className=''>{children}</div>;
};

PageContent.propTypes = {
	children: PropTypes.node.isRequired
};

export default PageContent;
